<div *ngIf="filtersBlock"
     [class]="filtersBlock.uId"
     [item]="filtersBlock"
     app-block>
</div>

<div *ngIf="resetBlock && showResetBlock"
     [class]="resetBlock.uId"
     [item]="resetBlock"
     app-block>
</div>